var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.734 8.65948C17.5213 8.44676 17.1764 8.44676 16.9637 8.65948L10.4381 15.1851L7.92983 12.6768C7.71713 12.4641 7.37228 12.4641 7.15954 12.6768C6.94682 12.8895 6.94682 13.2343 7.15954 13.4471L10.053 16.3405C10.2656 16.5532 10.6107 16.553 10.8233 16.3405L17.734 9.42977C17.9467 9.21707 17.9467 8.8722 17.734 8.65948Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.673feed75fd1eca59ee3147e9de986e1.svg";
export { ForwardRef as ReactComponent };